import { isEmpty } from '@jjj/components';
import actions from './actions';
import { createReducer } from '../../../../helpers/reducer';
import { keyBy } from '../../../../helpers/core';
import { t } from '../../../../i18n';

const initState = {
  partner: null,
  editForm: null,
  loading: false,
  isEdit: false,
  formInfo: {},
  deleted: false,
  isSavePartnerLoading: false,
};

const initialEditData = {
  name: null,
  referral_code: '',
  credit_card_incentive: 0,
  shift_manager_incentive: 0,
  status: '',
};

function validate(attr, value) {
  let error = '';

  if (attr === 'name') {
    if (isEmpty(value)) {
      error = t('dash.validation.required_error', { fieldName: t('dash.admin.partners.columns.name_title') });
    }
  }

  if (attr === 'referral_code') {
    if (isEmpty(value)) {
      error = t('dash.validation.required_error', { fieldName: t('dash.admin.partners.columns.referral_code_title') });
    } else if (value.length < 3) {
      error = t('dash.validation.min_length_error', {
        fieldName: t('dash.admin.partners.columns.referral_code_title'),
        length: 3,
      });
    }
  }

  if (attr === 'shift_manager_incentive') {
    if (typeof value !== 'number') {
      error = t('dash.validation.required_number_value', {
        fieldName: t('dash.admin.partners.shift_manager_incentive'),
      });
    }
  }

  if (attr === 'credit_card_incentive') {
    if (typeof value !== 'number') {
      error = t('dash.validation.required_number_value', {
        fieldName: t('dash.admin.partners.credit_card_incentive'),
      });
    }
  }

  if (attr === 'status') {
    if (isEmpty(value)) {
      error = t('dash.validation.select_a_field', { fieldName: t('dash.admin.partners.columns.status_title') });
    }
  }

  return error;
}

function onLoad(state) {
  return {
    ...state,
    loading: true,
  };
}

function onLoadSuccess(state, { payload }) {
  const { data } = payload;
  const partner = data;

  return {
    ...state,
    partner,
    loading: false,
  };
}

function onClearStore() {
  return { ...initState };
}

function onEdit(state, { payload }) {
  const propsArray = Object.keys(payload.partner);
  const editForm = keyBy(
    propsArray,
    prop => prop,
    prop => ({
      name: prop,
      value: payload.partner[prop],
      error: validate(prop, payload.partner[prop]),
      touched: false,
    }),
  );

  return {
    ...state,
    isEdit: true,
    editForm,
  };
}

function onSave(state) {
  return {
    ...state,
    isSavePartnerLoading: true,
  };
}

function onSaveSuccess(state, { payload }) {
  const { data } = payload;
  const partner = data;

  return {
    ...state,
    partner,
    isEdit: false,
    isSavePartnerLoading: false,
    editForm: null,
  };
}

function onSaveError(state) {
  return {
    ...state,
    isSavePartnerLoading: false,
  };
}

function onDelete(state) {
  return {
    ...state,
    isEdit: false,
    editForm: null,
  };
}

function onDeleteSuccess(state) {
  return {
    ...state,
    deleted: true,
  };
}

function onCreate(state) {
  const propsArray = Object.keys(initialEditData);
  const editForm = keyBy(
    propsArray,
    prop => prop,
    prop => ({
      name: prop,
      value: initialEditData[prop],
      error: validate(prop, initialEditData[prop]),
      touched: false,
    }),
  );

  return {
    ...state,
    isEdit: true,
    partner: initialEditData,
    editForm,
  };
}

function onAdd(state) {
  return {
    ...state,
    isEdit: false,
  };
}

function onChangeProperty(state, { payload }) {
  const { attr, value } = payload;
  const { editForm } = state;

  editForm[attr] = {
    value,
    error: validate(attr, value),
    name: attr,
    touched: true,
  };

  return {
    ...state,
    editForm: {
      ...editForm,
    },
  };
}

function onChangeProperties(state, { payload }) {
  const { attributes } = payload;
  const propsArray = Object.keys(attributes);

  const editFormProps = keyBy(
    propsArray,
    prop => prop,
    prop => ({
      name: prop,
      value: attributes[prop],
      error: validate(prop, attributes[prop]),
      touched: true,
    }),
  );

  const editForm = {
    ...state.editForm,
    ...editFormProps,
  };

  return {
    ...state,
    editForm,
  };
}

function onCancel(state) {
  return {
    ...state,
    isEdit: false,
    editForm: null,
  };
}

function onTouch(state, { payload }) {
  const propsArray = Object.entries(payload.editForm);
  const editForm = keyBy(
    propsArray,
    entry => entry[0],
    entry => {
      const [, value] = entry;

      return {
        ...value,
        touched: true,
      };
    },
  );

  return {
    ...state,
    editForm,
  };
}

function onLoadFormData(state, { payload }) {
  const { data } = payload;

  return {
    ...state,
    formInfo: data,
  };
}

export default createReducer(initState, {
  [actions.LOAD]: onLoad,
  [actions.LOAD_SUCCESS]: onLoadSuccess,
  [actions.CLEAR_STORE]: onClearStore,
  [actions.EDIT]: onEdit,
  [actions.CHANGE_PROPERTY]: onChangeProperty,
  [actions.CHANGE_PROPERTIES]: onChangeProperties,
  [actions.CANCEL]: onCancel,
  [actions.SAVE]: onSave,
  [actions.SAVE_SUCCESS]: onSaveSuccess,
  [actions.SAVE_ERROR]: onSaveError,
  [actions.ADD]: onAdd,
  [actions.DELETE]: onDelete,
  [actions.DELETE_SUCCESS]: onDeleteSuccess,
  [actions.CREATE]: onCreate,
  [actions.TOUCH]: onTouch,
  [actions.LOAD_FORM_DATA]: onLoadFormData,
});
